export enum NotificationType {
  Informational = 'Informational',
  Conversational = 'Conversational',
}
